import {
  ChangeDetectionStrategy,
  Component,
  Input
} from "@angular/core";
import {ServiceType} from "../../../../deliveries/types/service.type";

require('./planning-reports-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-planning-reports-table-row',
  templateUrl: './planning-reports-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningReportsTableRowComponent {

  @Input() report: any;

  constructor() {
  }

  protected readonly ServiceType = ServiceType;
}
